import { Moment } from '@intelipost-js/secure-providers';

export default {
  loading: false,
  hasGeneratedReport: false,
  dateRange: {
    start: Moment().subtract(1, 'days'),
    end: Moment().endOf('day'),
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/total-quote/store/states.js